import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class TypesService {

  constructor(private http: HttpClient) {}
  addType(body) {
    return this.http.post<ApiResponseModel>('api/tag/group', body);
  }
  getTypes() {
    return this.http.get<ApiResponseModel>('api/tag/group');
  }
  getTypeById(id) {
    return this.http.get<ApiResponseModel>('/api/tag/group/' + id);
  }
  editType(body, id) {
    return this.http.patch<ApiResponseModel>('/api/tag/group/' + id, body);
  }

}
